// extracted by mini-css-extract-plugin
export var createdDate = "_nb-1";
export var divider = "_nb-2";
export var headerDivider = "_nb-3";
export var messagesCard = "_nb-0";
export var messagesContainer = "_nb-6";
export var messagesContainerWrapper = "_nb-4";
export var showLeftPanelButton = "_nb-8";
export var topButtons = "_nb-7";
export var withPadding = "_nb-5";